import ProgressBarRevenueComponent from './ProgressBarRevenueComponent';

export default ProgressBarRevenueComponent;
